import React from "react";
import { useNavigate } from "react-router-dom";

import ArtCard from "../../../components/artCard";

const ListArt = (props) => {
  const { arts, loading } = props;
  const navigate = useNavigate();

  const onArtClick = (art_id) => {
    navigate(`/license/${art_id}`);
  };
  return (
    <div className="row">
      {loading ? (
        <h5>Please wait! Loading arts.......</h5>
      ) : arts?.length ? (
        arts?.map((arts) => (
          <ArtCard
            key={arts.id}
            name={arts?.name}
            description={arts?.description}
            previewImage={arts?.previewImage}
            onArtClick={() => onArtClick(arts?.id)}
          />
        ))
      ) : (
        <div className="d-flex justify-content-center">
          <p style={{ fontSize: "18px" }}>No licensable art available.</p>
        </div>
      )}
    </div>
  );
};

export default ListArt;
